"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchGetOtpChannel = void 0;
const fetchGetOtpChannel = (api, progressId) => api.GET(`${window.MIDDLEWARE_BASE_HOST}/mb-api-cm-operations/v1/otp/verification`, {
    headers: {
        progressId,
    },
});
exports.fetchGetOtpChannel = fetchGetOtpChannel;
//# sourceMappingURL=resolver.js.map